import Layout, { PageHeader } from "../components/Layout";
import SEO from "../components/SEO";
import { Stagger, StaggerItem, Reveal } from "../components/motion";
import { Cube } from "@phosphor-icons/react";
import { INDUSTRIES } from "../data/site";
import { IMAGES } from "../data/images";

export default function Industries() {
  return (
    <Layout>
      <SEO title="Industries" description="Eazymuv serves FMCG, food & frozen, ice cream, temperature-controlled and consumer-product supply chains." />
      <PageHeader eyebrow="Industries" title={<>High-velocity, temperature-critical supply chains</>} subtitle="We focus where execution discipline matters most — fast-moving goods, cold-chain integrity and dense distribution." image={IMAGES.frozenStacks} imageAlt="Cold-chain warehouse pallets" />
      <section className="max-w-[1600px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <Stagger className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border border-ez-text">
          {INDUSTRIES.map((ind, i) => (
            <StaggerItem key={i} className="group border-b border-r border-ez-border p-8 lg:p-10 hover:bg-ez-text hover:text-ez-bg transition-colors">
              <Cube size={28} weight="duotone" className="text-ez-yellow mb-6" />
              <div className="font-display text-2xl sm:text-3xl uppercase tracking-tighter leading-none break-words">{ind.name}</div>
              <p className="mt-4 text-sm opacity-70">{ind.note}</p>
            </StaggerItem>
          ))}
        </Stagger>
        <Reveal delay={0.1}>
          <div className="mt-10 text-sm text-ez-text/50 max-w-2xl">
            Indirectly-supported brands are never shown as direct customers. Customer
            references are published only with permission.
          </div>
        </Reveal>
      </section>
    </Layout>
  );
}
